import { AvailableOperationStatus } from "../operations/available-operation-status";
import { OperationRequest } from "../operations/operation-request";
import { Routes } from "../routes";
import { Strategy } from "./abstract-strategy";

export class SignatureStatusStrat extends Strategy {

    public hasCondition(request: OperationRequest): boolean {
        const availableStatus = [
            AvailableOperationStatus.FINALIZADA,
            AvailableOperationStatus.DOCUMENTACION_RECHAZADA,
            AvailableOperationStatus.RECHAZADA,
            AvailableOperationStatus.CADUCADA,
            AvailableOperationStatus.CANCELADA,
            AvailableOperationStatus.BLOQUEADA
        ];
        const hasStatus = request.idOperation && availableStatus.includes(request.state);
        const hasDeclineOperation = request.hasDeclineOperation && request.hasFinishCircuit;

        if (hasStatus || hasDeclineOperation) {
            return true;
        }
        return false;
    }

    public setStrategy(request?: OperationRequest): void {
        this.pathToGo = Routes.STATUS;
    }
}
